export const sortStatesByCustomerJurisdictions = (states, customerJurisdictions) => {
    return states.sort((a, b) => {
        if (customerJurisdictions.indexOf(a) >= 0) {
            return -1;
        }
        if (customerJurisdictions.indexOf(b) >= 0) {
            return +1;
        }

        if (a === b) {
            return 0;
        }

        return a < b ? -1 : 1;
    });
};
